export default __webpack_public_path__ + "static/media/bell.a921a9f2.wav";